import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '@/views/LandingPage.vue';
import AboutMe from '@/views/AboutMe.vue';
import Home from '@/views/Home.vue';
import ProjectDetails from '@/views/ProjectDetails.vue';

const routes = [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage,
  },
  {
    path: '/about',
    name: 'AboutMe',
    component: AboutMe,
  },
  {
    path: '/home',
    name: 'HOME',
    component: Home,
  },

  {
    path: '/projects/:id',
    name: 'Details',
    component: ProjectDetails,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
